import { render } from "./AnnaBoxed.vue?vue&type=template&id=bc13f5d0&scoped=true"
const script = {}

import "./AnnaBoxed.vue?vue&type=style&index=0&id=bc13f5d0&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc13f5d0"]])

export default __exports__